import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../App';
import brandModels from '../brandModels';
import brandBodyTypes from '../brandBodyTypes';
import { useTheme } from '../theme';
import { apiUrl } from '../api';

// const defaultCarModels = brandModels['BMW'];

const defaultCarBrands = [
  'Abarth', 'Acura', 'Alfa Romeo', 'Aston Martin', 'Audi', 'Bentley', 'BMW', 'Bugatti', 'Buick', 'Cadillac', 'Chevrolet', 'Chrysler', 'Citroën', 'Cupra', 'Dacia', 'Daewoo', 'Daihatsu', 'Dodge', 'DS', 'Ferrari', 'Fiat', 'Ford', 'Genesis', 'GMC', 'Honda', 'Hummer', 'Hyundai', 'Infiniti', 'Isuzu', 'Jaguar', 'Jeep', 'Kia', 'Lada', 'Lamborghini', 'Lancia', 'Land Rover', 'Lexus', 'Lincoln', 'Lotus', 'Maserati', 'Mazda', 'McLaren', 'Mercedes', 'MG', 'Mini', 'Mitsubishi', 'Nissan', 'Opel', 'Peugeot', 'Polestar', 'Pontiac', 'Porsche', 'RAM', 'Renault', 'Rolls-Royce', 'Rover', 'Saab', 'Seat', 'Skoda', 'Smart', 'SsangYong', 'Subaru', 'Suzuki', 'Tesla', 'Toyota', 'Volkswagen', 'Volvo', 'Other'
];
const defaultCarTypes = brandBodyTypes['BMW'];
const carYears = Array.from({ length: 30 }, (_, i) => 2025 - i);


export default function AddCar() {
  const navigate = useNavigate();
  const { tokens } = useTheme();
  const inputStyle = getInputStyle(tokens);
  const [marca, setMarca] = useState('BMW');
  const [model, setModel] = useState(brandModels['BMW'][0]);
  const [carBrands, setCarBrands] = useState(defaultCarBrands);
  const [carModels, setCarModels] = useState(brandModels['BMW']);
  const [carTypes, setCarTypes] = useState(defaultCarTypes);
  const [type, setType] = useState(defaultCarTypes[0]);
  const [years, setYears] = useState(carYears);
  const [year, setYear] = useState(carYears[0]);
  const [price, setPrice] = useState('');
  const [image, setImage] = useState(null); // File or URL
  const [msg, setMsg] = useState('');
  const [importUrl, setImportUrl] = useState('');
  const [importLoading, setImportLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [km, setKm] = useState('');
  const [combustibil, setCombustibil] = useState('');
  const [putere, setPutere] = useState('');
  const [cutie, setCutie] = useState('');
  const [capacitate, setCapacitate] = useState('');
  const [normaPoluare, setNormaPoluare] = useState('');
  const [description, setDescription] = useState('');
  const [dotari, setDotari] = useState([]); // Array of strings
  const [importedImages, setImportedImages] = useState([]); // Array of URLs
  const [selectedImageIdx, setSelectedImageIdx] = useState(0);
  const [seriaSasiu, setSeriaSasiu] = useState('');
  const { language } = useLanguage();
  const t = {
    en: {
      addCar: 'Add Car',
      model: 'Model',
      type: 'Type',
      year: 'Year',
      price: 'Price',
      image: 'Image',
      submit: 'Add Car',
      success: 'Car added!',
      error: 'Error adding car',
      placeholderPrice: 'Price',
      importTitle: 'Want to import from Autovit?',
      importDesc: 'Paste the listing link and it will auto-fill!',
      importBtn: 'Import',
      importLoading: 'Importing...',
      importError: 'Could not import from Autovit',
      brand: 'Brand',
      km: 'Km',
      fuel: 'Fuel',
      chooseFuel: 'Choose fuel',
      petrol: 'Petrol',
      diesel: 'Diesel',
      power: 'Power',
      powerPlaceholder: 'HP',
      gearbox: 'Gearbox',
      chooseGearbox: 'Choose gearbox',
      manual: 'Manual',
      automatic: 'Automatic',
      capacity: 'Capacity',
      capacityPlaceholder: 'cc',
      pollutionStandard: 'Pollution standard',
      choosePollution: 'Choose pollution standard',
      chassisNumber: 'VIN / Chassis number',
      chassisPlaceholder: 'VIN number',
      uploadingText: 'Uploading...',
      confirmNoVIN: 'You have not filled in the chassis number, do you want to upload the car like this?',
    },
    ro: {
      addCar: 'Adaugă Mașină',
      model: 'Model',
      type: 'Tip',
      year: 'An',
      price: 'Preț',
      image: 'Imagine',
      submit: 'Adaugă Mașină',
      success: 'Mașina a fost adăugată!',
      error: 'Eroare la adăugare',
      placeholderPrice: 'Preț',
      importTitle: 'Vrei să imporți din Autovit?',
      importDesc: 'Lipește linkul anunțului și se completează automat!',
      importBtn: 'Importă',
      importLoading: 'Se importă...',
      importError: 'Nu s-a putut importa de pe Autovit',
      brand: 'Marcă',
      km: 'Km',
      fuel: 'Combustibil',
      chooseFuel: 'Alege combustibil',
      petrol: 'Benzină',
      diesel: 'Motorină',
      power: 'Putere',
      powerPlaceholder: 'CP',
      gearbox: 'Cutie',
      chooseGearbox: 'Alege cutie viteze',
      manual: 'Manuală',
      automatic: 'Automată',
      capacity: 'Capacitate',
      capacityPlaceholder: 'cc',
      pollutionStandard: 'Normă de poluare',
      choosePollution: 'Normă de poluare',
      chassisNumber: 'VIN / Seria de șasiu',
      chassisPlaceholder: 'Număr VIN',
      uploadingText: 'Se încarcă...',
      confirmNoVIN: 'vezi ca Nu ai completat seria de sasiu, vrei sa incarci masina asa?',
    }
  };
  const tr = t[language];

  const handleSubmit = async (e) => {
    e.preventDefault();
    // If VIN/chassis is empty, ask for confirmation before proceeding
    if (!seriaSasiu || !seriaSasiu.trim()) {
      const proceed = window.confirm(tr.confirmNoVIN);
      if (!proceed) return;
    }
    setSubmitLoading(true);
    setMsg('');
    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('title', `${marca} ${model} ${type} ${year}`);
      formData.append('marca', marca);
      formData.append('model', model);
      formData.append('type', type);
      formData.append('year', year);
      // Sanitize price to a number if possible
      const priceSanitized = (() => {
        const s = String(price || '').trim();
        if (!s) return '';
        const compact = s.replace(/[^0-9.,-]/g, '');
        // If both separators exist, assume last is decimal
        const lastComma = compact.lastIndexOf(',');
        const lastDot = compact.lastIndexOf('.');
        let normalized = compact;
        if (lastComma !== -1 && lastDot !== -1) {
          normalized = lastComma > lastDot ? compact.replace(/\./g, '').replace(',', '.') : compact.replace(/,/g, '');
        } else if (lastComma !== -1) {
          const parts = compact.split(',');
          normalized = parts.length === 2 && parts[1].length === 3 ? compact.replace(/,/g, '') : compact.replace(',', '.');
        } else if ((compact.match(/\./g) || []).length > 1) {
          normalized = compact.replace(/\./g, '');
        }
        const n = Number(normalized);
        return Number.isFinite(n) ? String(n) : s;
      })();
      formData.append('price', priceSanitized);
      formData.append('km', km);
      formData.append('combustibil', combustibil);
      formData.append('putere', putere);
      formData.append('cutie', cutie);
      formData.append('capacitate', capacitate);
      if (seriaSasiu) formData.append('seriaSasiu', seriaSasiu.trim());
      if (normaPoluare) formData.append('normaPoluare', normaPoluare);
      if (description) formData.append('description', description);
      if (Array.isArray(dotari) && dotari.length > 0) {
        formData.append('dotari', JSON.stringify(dotari));
      }
      // Multi-image upload: append all images
      let hasFiles = false;
      if (importedImages && importedImages.length > 0) {
        for (const img of importedImages) {
          if (img instanceof File) {
            formData.append('images', img);
            hasFiles = true;
          }
        }
        // If importedImages are URLs, send them for backend to download
        const urlImages = importedImages.filter(img => typeof img === 'string' && img.startsWith('http'));
        if (urlImages.length > 0) {
          formData.append('importedImages', JSON.stringify(urlImages));
        }
      } else if (image) {
        formData.append('images', image);
        // hasFiles = true;
      }
      
      console.log('Submitting car with', formData.getAll('images').length, 'file uploads and', formData.get('importedImages') ? JSON.parse(formData.get('importedImages')).length : 0, 'URL images', 'hasFiles:', hasFiles);
      
      const res = await fetch(apiUrl('/api/cars'), {
        method: 'POST',
        headers: { Authorization: token },
        body: formData
      });
      
      if (res.ok) {
        try {
          const carData = await res.json();
          console.log('Car created successfully:', carData);
          const uploadStatus = carData._imageUploadStatus;
          if (uploadStatus && uploadStatus.requested > 0) {
            if (uploadStatus.success === uploadStatus.requested) {
              setMsg(tr.success + ` (${uploadStatus.success} imagini)`);
            } else if (uploadStatus.success > 0) {
              setMsg(tr.success + ` (${uploadStatus.success}/${uploadStatus.requested} imagini încărcate)`);
            } else {
              setMsg(tr.success + ' (fără imagini - verifică conexiunea și încearcă din nou)');
            }
          } else {
            setMsg(tr.success);
          }
        } catch (parseErr) {
          console.warn('Could not parse response JSON, but car was created successfully');
          setMsg(tr.success);
        }
        // Navigate after brief delay
        setTimeout(() => navigate('/'), 1500);
      } else {
        const errorData = await res.json().catch(() => ({}));
        console.error('Car submission error:', errorData);
        setMsg(tr.error + (errorData.error ? ': ' + errorData.error : ''));
      }
    } catch (err) {
      console.error('Car submission network error:', err);
      setMsg(tr.error + ': ' + err.message);
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleImport = async () => {
    const url = (importUrl || '').trim();
    if (!url) return;
    // Basic URL validation to avoid no-op clicks
    if (!/^https?:\/\//i.test(url)) {
      setMsg(language === 'ro' ? 'Te rog introdu un link valid (https://...)' : 'Please enter a valid URL (https://...)');
      return;
    }
    setImportLoading(true);
    setMsg('');
    try {
      const res = await fetch(apiUrl('/api/import-autovit'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url })
      });
      const data = await res.json();
      console.log('Autovit import response:', data); // Debug log
      if (res.ok && data) {
        // If imported marca is not in carBrands, add it
  // Always use the first word in the title as marca if present
  // let newMarca = data.title && typeof data.title === 'string' ? data.title.split(' ')[0] : (data.marca || marca);
        if (data.marca && !carBrands.includes(data.marca)) {
          setCarBrands(prev => [...prev, data.marca]);
        }
        // Use a single function to update all related state at once
        // Map Autovit 'type' to a valid caroserie
        const typeMap = {
          'SUV': ['SUV', '4x4'],
          'Break': ['Break', 'Combi', 'Wagon'],
          'Sedan': ['Sedan', 'Berlina'],
          'Hatchback': ['Hatchback'],
          'Coupe': ['Coupe'],
          'Convertible': ['Convertible', 'Cabrio'],
          'Pickup': ['Pickup'],
          'Van': ['Van', 'Minivan', 'MPV'],
          'Wagon': ['Wagon'],
          'Other': ['Utilizat', 'Altul', 'Other']
        };
        // Model to default type mapping for common models
        const modelTypeDefaults = {
          'Kuga': 'SUV',
          'Qashqai': 'SUV',
          'X5': 'SUV',
          'Golf': 'Hatchback',
          'Passat': 'Sedan',
          // Add more as needed
        };
        // Helper to remove accents/diacritics for robust comparison
        function normalize(str) {
          return str ? str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().trim() : '';
        }
        function mapType(rawType, model, availableTypes) {
          if (model && modelTypeDefaults[model]) return modelTypeDefaults[model];
          if (!rawType) return undefined;
          const t = normalize(rawType);
          // First, try typeMap
          for (const [key, arr] of Object.entries(typeMap)) {
            if (arr.some(v => t.includes(normalize(v)))) return key;
          }
          // Next, try to match to any available type for the brand (partial, case-insensitive, accent-insensitive)
          if (Array.isArray(availableTypes)) {
            const found = availableTypes.find(typeOpt => normalize(typeOpt) === t || t.includes(normalize(typeOpt)) || normalize(typeOpt).includes(t));
            if (found) return found;
          }
          return undefined;
        }
        // Ensure marca is set to the exact dropdown value
        let fixedMarca = carBrands.find(b => data.marca && b.toLowerCase() === data.marca.toLowerCase());
        // let updatedBrands = carBrands;
        if (!fixedMarca && data.marca) {
          // updatedBrands = [...carBrands, data.marca];
          fixedMarca = data.marca;
        }
  if (!fixedMarca && data.marca) fixedMarca = data.marca;
        let models = brandModels[fixedMarca] || ['Other'];
        let types = brandBodyTypes[fixedMarca] || ['Other'];
        // If imported model is not in the list, add it
        if (data.model && !models.includes(data.model)) {
          models = [...models, data.model];
        }
        // Map imported type to valid type, prefer model-based default
        let mappedType = mapType(data.type, data.model, types);
        if (mappedType && !types.includes(mappedType)) {
          types = [...types, mappedType];
        }
        const newModel = data.model ? data.model : models[0];
        // If mappedType is not found, fallback to first available type, else 'Other'
        const newType = mappedType ? mappedType : (types[0] || 'Other');
        // Set all state at once to avoid race conditions
        setMarca(fixedMarca);
        setCarModels(models);
        setCarTypes(types);
        setModel(newModel);
        setType(newType);
        // Year: robustly extract a 4-digit year and ensure it exists in options; if missing, add it to local options
        const pickYear = () => {
          const tryExtract = (s) => {
            if (!s) return null;
            const m = String(s).match(/\b(19|20)\d{2}\b/);
            return m ? parseInt(m[0], 10) : null;
          };
          let y = tryExtract(data.year);
          if (!y) y = tryExtract(data.title);
          if (!y) y = tryExtract(data.description);
          const now = new Date().getFullYear() + 1;
          if (y && y >= 1980 && y <= now) return y;
          return null;
        };
        const gotYear = pickYear();
        if (Number.isInteger(gotYear)) {
          // ensure it's available in dropdown
          setYears(prev => (prev.includes(gotYear) ? prev : [...prev, gotYear].sort((a,b)=>b-a)));
          setYear(gotYear);
        }
        setPrice(data.price || price);
        setKm(data.km || '');
        // Normalize imported combustibil and cutie to dropdown values
        const combustibilOptions = ['Benzina', 'Motorina', 'Hibrid', 'Electric', 'GPL', 'Altul'];
        const cutieOptions = ['Manuala', 'Automata', 'CVT', 'DSG', 'Tiptronic', 'Altul'];
        function normalizeDropdown(val, options) {
          if (!val) return '';
          let norm = val.trim().toLowerCase();
          // Fix common spelling for hibrid
          if (norm === 'hybrid' || norm === 'hibrid' || norm === 'hibryd') norm = 'hybrid';
          if (norm === 'diesel') norm = 'motorina';
          if (norm === 'petrol') norm = 'benzina';
          for (const opt of options) {
            if (norm === opt.toLowerCase()) return opt;
            if (norm.includes(opt.toLowerCase())) return opt;
          }
          return 'Altul';
        }
        setCombustibil(normalizeDropdown(data.combustibil, combustibilOptions));
        setPutere(data.putere || '');
        setCutie(normalizeDropdown(data.cutie, cutieOptions));
        setCapacitate(data.capacitate || '');
        // Norma de poluare (Euro 3..Euro 6)
        const mapNorma = (val) => {
          if (!val) return '';
          const raw = String(val).trim();
          const s = raw.toLowerCase();
          const m1 = s.match(/\beuro\s*([3-6])\b/);
          if (m1) return `Euro ${m1[1]}`;
          // Avoid hitting digits within CO2 values like 136
          const m2 = s.match(/(?:^|[^0-9])([3-6])(?:[^0-9]|$)/);
          return m2 ? `Euro ${m2[1]}` : '';
        };
        let mappedNorma = mapNorma(data.normaPoluare);
        // Fallback: try to infer from features (dotari) or description if backend missed it
        if (!mappedNorma) {
          const fromDotari = Array.isArray(data.dotari)
            ? data.dotari.map(String).map(s=>s.toLowerCase()).find(s => /\b(euro)\s*[3-6]\b/.test(s))
            : null;
          if (fromDotari) mappedNorma = mapNorma(fromDotari);
        }
        if (!mappedNorma && data.description) {
          const desc = String(data.description).toLowerCase();
          const m1 = desc.match(/\beuro\s*([3-6])\b/);
          if (m1) mappedNorma = `Euro ${m1[1]}`;
          if (!mappedNorma) {
            const m2 = desc.match(/(?:^|[^0-9])([3-6])(?:[^0-9]|$)/);
            mappedNorma = `Euro ${m2[1]}`;
          }
        }
        setNormaPoluare(mappedNorma);
        // VIN / Seria de șasiu
        if (data.vin || data.VIN || data.seriaSasiu) {
          setSeriaSasiu(data.vin || data.VIN || data.seriaSasiu || '');
        }
        // Description and features (Dotări)
        setDescription((data.description || '').trim());
        setDotari(Array.isArray(data.dotari) ? data.dotari : []);
        if (data.images && data.images.length > 0) {
          // Client-side safety: filter out low-quality/thumb variants and deduplicate
          // Keep good-quality images even if they have quality=80/90; only drop obvious thumbnails/blur
          const isLowQuality = (u) => /thumb|small|placeholder|blur|mini|_q\d/i.test(String(u));
          const normalizeKey = (u) => String(u)
            .split('?')[0]
            .replace(/(-|\.)\d{2,4}x\d{2,4}(?=\.)/i, '')
            .replace(/[,/_-](w|h)_\d{2,4}/gi, '')
            .toLowerCase();
          const seen = new Set();
          const unique = [];
          for (const u of data.images) {
            if (!u || typeof u !== 'string') continue;
            if (isLowQuality(u)) continue;
            const key = normalizeKey(u);
            if (seen.has(key)) continue;
            seen.add(key);
            unique.push(u);
          }
          // Show imported image URLs immediately in preview
          setImportedImages(unique);
          setSelectedImageIdx(0);
          setImage(unique[0] || null);
          console.log(`✓ Loaded ${unique.length} images for preview`);
          // Backend will download these URLs when car is submitted
        } else {
          setImportedImages([]);
          setSelectedImageIdx(0);
          setImage(null);
        }
        setMsg('');
      } else {
        setMsg(tr.importError);
      }
    } catch {
      setMsg(tr.importError);
    } finally {
      setImportLoading(false);
    }
  };

  // Warm up the import route (Puppeteer) on first mount to avoid first-click delays
  useEffect(() => {
    let aborted = false;
    (async () => {
      try {
        const ctrl = new AbortController();
        const t = setTimeout(() => ctrl.abort(), 10000);
        await fetch(apiUrl('/api/import-autovit/warmup'), { signal: ctrl.signal }).catch(() => {});
        clearTimeout(t);
      } catch {}
      if (aborted) return;
    })();
    return () => { aborted = true; };
  }, []);

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 420, margin: '32px auto', background: tokens.surface, borderRadius: 16, boxShadow: `0 4px 24px ${tokens.shadow}`, padding: 32, display: 'flex', flexDirection: 'column', gap: 16, color: tokens.text }}>
      <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 16, textAlign: 'center' }}>{tr.addCar}</h2>
  <div style={{ background: tokens.panel, borderRadius: 8, padding: 16, marginBottom: 16 }}>
  <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>{tr.importTitle}</div>
  <div style={{ fontSize: 15, color: tokens.textMuted, marginBottom: 8 }}>{tr.importDesc}</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <input value={importUrl} onChange={e => setImportUrl(e.target.value)} placeholder="https://www.autovit.ro/autoturisme/anunt/..." style={{ ...inputStyle, flex: 1 }} />
          <button type="button" onClick={handleImport} disabled={importLoading} style={{ background: `linear-gradient(90deg, ${tokens.accent} 0%, ${tokens.accent2} 100%)`, color: tokens.inverse, border: 'none', borderRadius: 8, padding: '8px 16px', fontWeight: 700, fontSize: 16, cursor: 'pointer', boxShadow: `0 2px 8px ${tokens.shadowSoft}`, transition: 'background 0.2s' }}>{importLoading ? tr.importLoading : tr.importBtn}</button>
        </div>
      </div>
      <label style={{ fontWeight: 600 }}>{tr.brand}</label>
      <select
        value={marca}
        onChange={e => {
          const selectedBrand = e.target.value;
          setMarca(selectedBrand);
          // Update models for selected brand
          const models = brandModels[selectedBrand] || ['Other'];
          setCarModels(models);
          setModel(models[0]);
          // Update types for selected brand
          const types = brandBodyTypes[selectedBrand] || ['Other'];
          setCarTypes(types);
          setType(types[0]);
        }}
  style={inputStyle}
      >
        {carBrands.map(b => <option key={b} value={b}>{b}</option>)}
      </select>
      <label style={{ fontWeight: 600 }}>{tr.model}</label>
  <select value={model} onChange={e => setModel(e.target.value)} style={inputStyle}>
        {carModels.map(m => <option key={m} value={m}>{m}</option>)}
      </select>
      <label style={{ fontWeight: 600 }}>{tr.type}</label>
  <select value={type} onChange={e => setType(e.target.value)} style={inputStyle}>
        {carTypes.map(t => <option key={t} value={t}>{t}</option>)}
      </select>
  <label style={{ fontWeight: 600 }}>{tr.year}</label>
  <select value={year} onChange={e => setYear(parseInt(e.target.value, 10))} style={inputStyle}>{years.map(y => <option key={y} value={y}>{y}</option>)}</select>
      <label style={{ fontWeight: 600 }}>{tr.price}</label>
      <input
        placeholder={tr.placeholderPrice}
        value={formatNumberSpaces(price)}
        onChange={e => {
          // Remove spaces for state, allow only digits
          const raw = e.target.value.replace(/\s+/g, '');
          if (/^\d*$/.test(raw)) setPrice(raw);
        }}
        required
  style={inputStyle}
      />
      <label style={{ fontWeight: 600 }}>{tr.km}</label>
      <input
        placeholder={tr.km}
        value={formatNumberSpaces(km)}
        onChange={e => {
          const raw = e.target.value.replace(/\s+/g, '');
          if (/^\d*$/.test(raw)) setKm(raw);
        }}
  style={inputStyle}
      />
      <label style={{ fontWeight: 600 }}>{tr.fuel}</label>
  <select value={combustibil} onChange={e => setCombustibil(e.target.value)} style={inputStyle}>
        <option value="">{tr.chooseFuel}</option>
        <option value="Benzina">{tr.petrol}</option>
        <option value="Motorina">{tr.diesel}</option>
        <option value="Hybrid">Hybrid</option>
        <option value="Electric">Electric</option>
        <option value="GPL">LPG</option>
        <option value="Altul">{language === 'ro' ? 'Altul' : 'Other'}</option>
      </select>
      <label style={{ fontWeight: 600 }}>{tr.power}</label>
  <input placeholder={tr.powerPlaceholder} value={putere} onChange={e => setPutere(e.target.value)} style={inputStyle} />
      <label style={{ fontWeight: 600 }}>{tr.gearbox}</label>
  <select value={cutie} onChange={e => setCutie(e.target.value)} style={inputStyle}>
        <option value="">{tr.chooseGearbox}</option>
        <option value="Manuala">{tr.manual}</option>
        <option value="Automata">{tr.automatic}</option>
        <option value="CVT">CVT</option>
        <option value="DSG">DSG</option>
        <option value="Tiptronic">Tiptronic</option>
        <option value="Altul">{language === 'ro' ? 'Altul' : 'Other'}</option>
      </select>
      <label style={{ fontWeight: 600 }}>{tr.capacity}</label>
  <input placeholder={tr.capacityPlaceholder} value={capacitate} onChange={e => setCapacitate(e.target.value)} style={inputStyle} />
      {/* Norma de poluare */}
      <label style={{ fontWeight: 600 }}>{tr.pollutionStandard}</label>
  <select value={normaPoluare} onChange={e => setNormaPoluare(e.target.value)} style={inputStyle}>
        <option value="">{tr.choosePollution}</option>
        <option value="Euro 3">Euro 3</option>
        <option value="Euro 4">Euro 4</option>
        <option value="Euro 5">Euro 5</option>
        <option value="Euro 6">Euro 6</option>
      </select>
      {/* Description */}
      <label style={{ fontWeight: 600 }}>{language === 'ro' ? 'Descriere' : 'Description'}</label>
      <textarea
        placeholder={language === 'ro' ? 'Descriere anunț (importată automat dacă există)' : 'Listing description (auto-imported if available)'}
        value={description}
        onChange={e => setDescription(e.target.value)}
        rows={4}
  style={{ ...inputStyle, minHeight: 96, resize: 'vertical' }}
      />
      {/* Dotari (Features) */}
      <label style={{ fontWeight: 600 }}>{language === 'ro' ? 'Dotări' : 'Features'}</label>
      <textarea
        placeholder={language === 'ro' ? 'Listează dotările, una pe linie. (Se importă automat din Autovit dacă există)' : 'List features, one per line. (Auto-imported from Autovit if available)'}
        value={Array.isArray(dotari) ? dotari.join('\n') : ''}
        onChange={e => setDotari(e.target.value.split(/\r?\n/).map(s => s.trim()).filter(Boolean))}
        rows={4}
  style={{ ...inputStyle, minHeight: 96, resize: 'vertical' }}
      />
      <label style={{ fontWeight: 600 }}>{tr.image}</label>
      {/* Image preview gallery for imported images */}
      {importedImages.length > 0 && (
        <div style={{ display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
          {importedImages.map((img, idx) => {
            const src = img instanceof File ? URL.createObjectURL(img) : img;
            return (
              <img
                key={src}
                src={src}
                alt={"imported-" + idx}
                style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 6, border: idx === selectedImageIdx ? `2px solid ${tokens.accent}` : `2px solid ${tokens.mutedBorder}` , cursor: 'pointer' }}
                onClick={() => { setSelectedImageIdx(idx); setImage(img); }}
              />
            );
          })}
        </div>
      )}
      {/* Main image preview (file or url) */}
      {image && (
        <img
          src={image instanceof File ? URL.createObjectURL(image) : image}
          alt="selected"
          style={{ width: 120, height: 90, objectFit: 'cover', borderRadius: 8, marginBottom: 8, border: `2px solid ${tokens.accent}` }}
        />
      )}
      {/* Show formatted price and km preview */}
  <div style={{ color: tokens.textMuted, fontSize: 15, marginBottom: 8 }}>
        {price && <span>{language === 'ro' ? 'Preț' : 'Price'}: {formatNumberSpaces(price)} €</span>}
        {km && <span style={{ marginLeft: 16 }}>{tr.km}: {formatNumberSpaces(km)}</span>}
      </div>

      <input type="file" multiple onChange={e => {
        const files = Array.from(e.target.files);
        setImportedImages(files);
        setImage(files[0] || null);
  }} style={{ ...getInputStyle(tokens), background: tokens.panel, color: tokens.text, border: 'none' }} />
      {/* Seria de șasiu (VIN) - moved after photos */}
      <label style={{ fontWeight: 600 }}>{tr.chassisNumber}</label>
      <input
        placeholder={tr.chassisPlaceholder}
        value={seriaSasiu}
        onChange={e => setSeriaSasiu(e.target.value.toUpperCase())}
  style={inputStyle}
      />
  <button type="submit" disabled={submitLoading} style={{ background: submitLoading ? tokens.mutedBorder : `linear-gradient(90deg, ${tokens.accent} 0%, ${tokens.accent2} 100%)`, color: tokens.inverse, border: 'none', borderRadius: 8, padding: '12px 0', fontWeight: 700, fontSize: 18, cursor: submitLoading ? 'not-allowed' : 'pointer', marginTop: 8, boxShadow: `0 2px 8px ${tokens.shadowSoft}`, transition: 'background 0.2s' }}>{submitLoading ? tr.uploadingText : tr.submit}</button>
  {msg && <p style={{ color: msg.includes(tr.error) || msg === tr.importError ? '#ff5252' : tokens.accent, textAlign: 'center', marginTop: 8 }}>{msg}</p>}
    </form>

  );
}

function getInputStyle(tokens) {
  return {
    background: tokens.panel,
    color: tokens.text,
    border: `1px solid ${tokens.mutedBorder}`,
    borderRadius: 8,
    padding: '10px 12px',
    fontSize: 16,
    marginBottom: 0,
  };
}

// Helper to format numbers with spaces as thousands separators
function formatNumberSpaces(num) {
  if (num === undefined || num === null) return '';
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
